import { formatDate } from "date-fns";
import { useMemo } from "react";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import type { PinCandidate } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/pinKind";
import {
	relatedCandidateSubtitle,
	relatedCandidateTitle,
} from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/relatedCandidateLabels";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";

export type PinCandidateRow = {
	key: string;
	candidate: PinCandidate;
	title: string;
	subtitle?: string;
};

export const usePinCandidateRows = (
	candidates: PinCandidate[],
): PinCandidateRow[] => {
	const { t } = useResource();

	return useMemo(
		() =>
			candidates.map((candidate) => {
				if (candidate.kind === "document") {
					return {
						key: `document-${candidate.data.id}`,
						candidate,
						title: candidate.data.title,
						subtitle: candidate.data.createdAt
							? formatDate(
									new Date(candidate.data.createdAt),
									DateFormat.Display,
								)
							: undefined,
					};
				}

				return {
					key: `related-${candidate.data.myplannId}`,
					candidate,
					title: relatedCandidateTitle(candidate.data, t),
					subtitle: relatedCandidateSubtitle(candidate.data),
				};
			}),
		[candidates, t],
	);
};
